module.exports = __webpack_public_path__ + "6c6bbf0f9a1ded7549fb59eeb606e3e3.png";